import type { GetUserSubscriptionsStatus } from './getUserSubscriptionsStatus';

export type GetUserSubscriptionsParams = {
/**
 * 구독 상태 필터 (선택사항)
 */
status?: GetUserSubscriptionsStatus;
};
